import { useState } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const STORAGE_KEY = "divisionBriefingBetaBannerDismissed";

function readDismissed(): boolean {
  if (typeof window === "undefined") return false;
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function DivisionBriefingBetaBanner() {
  const [dismissed, setDismissed] = useState(readDismissed);

  if (dismissed) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* ignore quota / private mode */
    }
    setDismissed(true);
  };

  return (
    <div
      className="flex shrink-0 items-center gap-0.5 border-b border-border bg-muted/25 px-2 py-0.5 pr-0.5"
      role="status"
    >
      <p className="min-w-0 flex-1 text-[11px] leading-snug text-muted-foreground">
        <span className="font-medium text-foreground/85">Beta</span>
        <span className="mx-1 text-border" aria-hidden>
          ·
        </span>
        Division Briefing is in beta; metrics and layout may change.
      </p>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-6 shrink-0 rounded-sm text-muted-foreground hover:bg-muted/80 hover:text-foreground"
        aria-label="Dismiss beta notice"
        onClick={dismiss}
      >
        <X className="size-3.5" aria-hidden />
      </Button>
    </div>
  );
}
